import PropTypes from 'prop-types';
import React, { useMemo, useState } from 'react';

import moment from 'moment'
import { Badge, DefaultTable, DropdownMenu, DropdownMenuContent, DropdownMenuTrigger, Input, cn } from 'twyne-new.ui';

import { formatDateTime } from 'utils';

const propTypes = {
  jobs: PropTypes.array,
};

export default function InProgress({ jobs }) {
  const columns = [{
    dataField: 'timestamp',
    text: 'Job requested at',
    formatter: value => formatDateTime(moment(value)),
  }, {
    dataField: 'type',
    text: 'Status',
    formatter: status => <Badge variant='light' color={colors[status]}>
      {status}
    </Badge>,
  }, {
    dataField: 'emails',
    text: 'E-mails',
    formatter: EmailFormatter,
  }, {
    dataField: 'integrationId',
    text: 'IntegrationId',
    formatter: (_, row) => row.data.integrationId || '--',
  }]

  return <DefaultTable
    keyField='id'
    data={jobs}
    columns={columns}
    noDataIndication={() => 'No jobs in progress.'}
    sticky={true}
    className='max-h-[50vh] overflow-y-auto'
  />
}

const EmailFormatter = (_, row) => {
  const emails = (row.result && row.result) || row.data.emails || []
  return <EmailPopover emails={emails} />
}

function EmailPopover({ emails }) {
  const [open, setOpen] = useState(false)
  const [search, setSearch] = useState('')

  const filteredEmails = useMemo(() => {
    const term = search.trim().toLowerCase()

    if (!term) {
      return emails
    }

    return emails.filter(email => `${email}`.toLowerCase().includes(term))
  }, [emails, search])

  return <DropdownMenu open={open} onOpenChange={setOpen}>
    <DropdownMenuTrigger>
      <span className={cn('twy-text-base-accent hover:underline cursor-pointer', open && 'underline')} onMouseEnter={() => setOpen(true)}>
        {emails.length}
      </span>
    </DropdownMenuTrigger>
    <DropdownMenuContent className='p-2 w-80' align='end'>
      <Input
        value={search}
        onChange={e => setSearch(e.target.value)}
        placeholder='Search email...'
        onKeyDown={e => e.stopPropagation()}
      />
      <div className='max-h-56 overflow-y-auto mt-2'>
        {filteredEmails.length ? filteredEmails.map((email, idx) => <div key={`${email}-${idx}`} className='px-2 py-1 hover:twy-bg-base rounded-xs'>
          {email}
        </div>) : <div className='px-2 py-1 twy-text-base-neutral'>No emails found.</div>}
      </div>
    </DropdownMenuContent>
  </DropdownMenu>
}

const colors = {
  waiting: 'warning',
  active: 'accent',
  delayed: 'neutral',
  completed: 'success',
  failed: 'danger',
}

InProgress.propTypes = propTypes
InProgress.defaultProps = {}
